export enum OAuth2OktaPrompt {
    None = 'none',
    Login = 'login',
    Consent = 'consent',
}
